import React, { useState } from 'react';
import { Grid, Typography, Checkbox, MenuItem, TextField, Autocomplete } from '@mui/material';

import { Colors, isLightTheme } from '../config/default';

export default function DropdownEmails({
  index,
  setMails,
  mails,
  apiData,
  toShow,
  fullWidth,
  searchMessage,
  hideLabel,
  bordered
}) {
  const [selectedMail, setSelectedMail] = useState(
    (toShow === 'policy' ? mails[index] : toShow === 'vendor' ? mails : []) || []
  );

  const handleChange = (event, newValue) => {
    const validValues = newValue?.filter(Boolean) || [];

    setSelectedMail(validValues);

    if (toShow === 'vendor') {
      setMails(validValues);
    } else {
      const updatedEmails = [...mails];
      updatedEmails[index] = validValues;
      setMails(updatedEmails);
    }
  };

  return (
    <div>
      <Grid item>
        {toShow !== 'canvas' && toShow !== 'vendor' && !hideLabel && (
          <Typography
            sx={{
              fontSize: '0.75em',
              color: Colors.WHITE,
              marginBottom: '.5rem'
            }}>
            Approver {index + 1}
          </Typography>
        )}

        <Autocomplete
          multiple
          disableCloseOnSelect
          options={apiData || []}
          value={selectedMail}
          onChange={handleChange}
          getOptionLabel={(option) => option || ''}
          renderTags={() => null}
          slotProps={{
            paper: {
              sx: {
                '& .MuiAutocomplete-noOptions': {
                  fontSize: '10px',
                  color: Colors.TEXTGREY
                },
                backgroundColor: Colors.GREY,
                borderRadius: '10px'
              }
            }
          }}
          noOptionsText={
            toShow === 'canvas'
              ? "you don't have registered users"
              : toShow === 'vendor'
              ? 'Your selected list is empty'
              : "you don't have more users"
          }
          renderOption={(props, option, { selected }) => (
            <MenuItem
              {...props}
              sx={{
                color: Colors.TEXTGREY,
                borderRadius: '6px',
                width: '100%',
                padding: '4px 10px',
                display: 'flex',
                alignItems: 'center',
                '&:hover': { backgroundColor: 'transparent' },
                '&.Mui-focused': { backgroundColor: 'transparent' }
              }}>
              <Checkbox
                size="small"
                style={{ color: Colors.TEXTGREY, padding: 4 }}
                checked={selected}
              />
              <Typography
                sx={{
                  fontSize: toShow === 'canvas' ? '1rem' : '.9em',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }}>
                {option}
              </Typography>
            </MenuItem>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder={
                selectedMail.length === 0
                  ? toShow === 'canvas'
                    ? 'Select a user for approval'
                    : searchMessage
                  : ''
              }
              inputProps={{
                ...params.inputProps,
                value: params.inputProps.value || selectedMail.join(', ')
              }}
              sx={{
                borderRadius: bordered ? '9px' : '8px',
                backgroundColor:
                  isLightTheme() && toShow === 'canvas' ? '#FFFFFF' : Colors.Canvas_BG,

                input: {
                  color: Colors.TEXTGREY,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  fontSize: toShow === 'canvas' ? '1rem' : '12px'
                },

                '& .MuiOutlinedInput-root': {
                  // `bordered` (policy page) → the 40px bordered field from the
                  // approved design; other callers keep their existing look.
                  height: bordered ? '40px' : toShow === 'canvas' ? '3.1em' : '32px',
                  paddingTop: 0,
                  paddingBottom: 0,
                  alignItems: 'center',
                  border: bordered
                    ? `1px solid ${isLightTheme() ? 'rgba(0,0,0,0.16)' : 'rgba(255,255,255,0.12)'}`
                    : toShow === 'canvas'
                    ? `1px solid ${Colors.LIGHTGREY}`
                    : 'none',
                  borderRadius: bordered ? '9px' : toShow === 'canvas' ? '10px' : '0px',

                  '& fieldset': { border: 'none' },
                  '&:hover fieldset': { border: 'none' },
                  '&.Mui-focused fieldset': { border: 'none' }
                }
              }}
            />
          )}
          sx={{
            width: fullWidth ? '100%' : toShow === 'canvas' ? '100%' : '11.25em'
          }}
        />
      </Grid>
    </div>
  );
}
